import request from '@/utils/request'
 // 供应明细界面实例

  export function apiListMpsSupplierName (query) {
    return request({
      url: `/scp/scpMpsPlans/listMpsSupplierName`,
      method: 'get',
      params: query
    })
  }
  export function apiListSupplierCode (query) {
    return request({
      url: `/scp/scpMpsPlans/listSupplierCode`,
      method: 'get',
      params: query
    })
  }
  export function apiListSupplierCodePage (query) {
    return request({
      url: `/scp/scpMpsPlans/pageSupplierCode`,
      method: 'get',
      params: query
    })
  }
 export function apiFindPageSupplierDetail (query) {
    return request({
      url: `/scp/scpMpsPlans/findPageSupplierDetail`,
      method: 'get',
      params: query
    })
  }

  export function apiLeadByItemCode (query) {
    return request({
      url: `/scp/scpMpsPlans/leadByItemCode`,
      method: 'get',
      params: query
    })
  }
  // 获取供应商详细的信息
  export function apiLeadBySupplierCode (query) {
    return request({
      url: `/scp/scpMpsPlans/leadBySupplierCode`,
      method: 'get',
      params: query
    })
  }
  // 查询供应商明细单据编码
  export function apiGetOrderNumber (query) {
    return request({
      url: `/scp/scpMpsPlans/getOrderNumber`,
      method: 'get',
      params: query
    })
  }
  // 编辑行数据保存接口
  export function apiEditSupplierDetail (query) {
    return request({
      url: `/scp/scpMpsPlans/editSupplierDetail`,
      method: 'post',
      data: query
    })
  }
  // 封装成以下形式调用接口/scpMpsPlans/addSupplierDetail添加计划单，
  export function apiAddSupplierDetail (query) {
    return request({
      url: `/scp/scpMpsPlans/addSupplierDetail`,
      method: 'post',
      data: query
    })
  }
    // 删除计划单
    export function apiDeleteSupplierDetail (id) {
      return request({
        url: `/scp/scpMpsPlans/deleteSupplierDetail/${id}`,
        method: 'get'
      })
    }

    // 批量删除计划单
    export function apiBatchDeleteSupplierDetail (query) {
      return request({
        url: `/scp/scpMpsPlans/batchDeleteSupplierDetail`,
        method: 'get',
        params: query
      })
    }
